import z from 'zod';
import { catalystSubcategoriesSchema } from '../catalyst-insights';

const eventFeedBasePath = 'event-feed/v1/';

const eventFeedTypeZodEnum = z.enum([
  'scenario-insight',
  'earnings-insight',
  'attribution-insight',
  'market-overview',
]);
export type EventFeedType = z.infer<typeof eventFeedTypeZodEnum>;

export const eventFeedRequestSchema = z.object({
  watchlists: z.array(z.string()).optional(),
  competitors: z.boolean().optional(),
  entities: z.array(z.string()).optional(),
  type: eventFeedTypeZodEnum.optional(),
  limit: z.number().int().optional(),
  next: z.string().optional(),
  prev: z.string().optional(),
});

const relevanceConnectionSchema = z.object({
  entity: z.string(),
  watchlist_ids: z.array(z.string()),
});

const relevanceTierSchema = z.union([z.literal(1), z.literal(2), z.literal(3)]);
export type RelevanceTier = z.infer<typeof relevanceTierSchema>;

const relevanceSchema = z.object({
  tier: relevanceTierSchema,
  connections: z.array(relevanceConnectionSchema).nullish(),
  watchlist_ids: z.array(z.string()).nullish(),
});

const eventSchema = z.object({
  id: z.string(),
  type: eventFeedTypeZodEnum,
  entity: z.string(),
  created_at: z.string(),
  title: z.string(),
  summary: z.string().nullish(),
  metadata: z
    .object({
      earnings_id: z.string().nullish(),
      earnings_type: z.enum(['preview', 'recap']).nullish(),
      median_return: z.number().nullish(),
      horizon: z.string().nullish(),
      stars: z.number().nullish(),
      episode_count: z.number().nullish(),
      action_type: z.string().nullish(),
      category: z.enum(['market_wide', 'company']).nullish(),
      sub_category: catalystSubcategoriesSchema.nullish(),
    })
    .catchall(z.unknown()),
  read: z.boolean(),
  relevance: relevanceSchema,
});

export const eventFeedResponseSchema = z.object({
  events: z.array(eventSchema),
  next_cursor: z.string().nullish(),
  prev_cursor: z.string().nullish(),
});

export type EventFeedRequest = z.infer<typeof eventFeedRequestSchema>;
export type EventFeedResponse = z.infer<typeof eventFeedResponseSchema>;
export type EventFeedEvent = z.infer<typeof eventSchema>;
export type EventFeedRelevance = z.infer<typeof relevanceSchema>;
export type EventFeedRelevanceTier = z.infer<typeof relevanceTierSchema>;
export type EventFeedRelevanceConnection = z.infer<
  typeof relevanceConnectionSchema
>;

export const eventFeed = {
  postFeedEvents: {
    path: `${eventFeedBasePath}events`,
    schema: eventFeedResponseSchema,
  },
  postEventRead: {
    path: (eventId: string) => `${eventFeedBasePath}events/${eventId}/read`,
  },
};
